import { createTheme } from '@mui/material/styles'

import { PresetColor, ThemeMode } from 'types'

import { BRAND_ACCENT, BRAND_ACCENT_HOVER } from './brandColors'

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (mode: ThemeMode, presetColor: PresetColor) => {
  return createTheme({
    palette: {
      primary: {
        main: '#264653',
        light: '#D4DADD',
        lighter: '#F5F7F7',
        dark: '#80A0AD',
        contrastText: '#fff',
        100: '#EAECF0',
      },
      /** Brand accent — use `brandColors.ts` (single source of truth) */
      secondary: {
        lighter: '#E8F6F4',
        light: BRAND_ACCENT_HOVER,
        main: BRAND_ACCENT,
        dark: '#1F7F73',
        darker: '#1A6B62',
        contrastText: '#fff',
        100: '#E8F8F4',
        200: '#5B6A7B',
        300: '#475467',
        400: '#12B76A',
        500: '#027A48',
        600: '#E0E0E0',
        700: '#238A7E',
      },
      info: {
        main: BRAND_ACCENT,
        100: '#34C14B', //green for thhe chip component
        200: '#ECFDF3', //lightgreen
        300: '#2E90FA', //blue
        400: '#EFF8FF', //lightblue
        500: '#FAAD14', //yellow
        600: 'rgba(242, 212, 125, 0.2)', //lightyellow
        700: '#F86E6E', //red
        800: 'rgba(248, 110, 110, 0.1)', //lightred
        900: '#274553', //for avatar
      },
      text: {
        primary: '#264653',
        secondary: '#516B75',
      },
      background: {
        default: '#fff',
      },
      warning: {
        main: '#F86E6E',
        light: '#ed6c020d',
        dark: '#F86E6E',
      },
    },
  })
}

export default Palette
